module.exports = __webpack_public_path__ + "82c5abd4103ecdf67cbe40956be3d1ce.woff";